import { Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { ErrorBoundary } from './components/ErrorBoundary';
import { LoadingScreen } from './components/ui/LoadingScreen';
import CheckoutFooter from './components/common/Footer';

// Lazy load pages for code splitting
const CheckoutPage = lazy(() => import('./pages/CheckoutPage'));
const PreviewPage = lazy(() => import('./pages/PreviewPage'));
const SuccessPage = lazy(() => import('./pages/SuccessPage'));
const OperationStatusPage = lazy(() => import('./pages/OperationStatusPage'));
const ErrorPage = lazy(() => import('./pages/ErrorPage'));
const ExpiredPage = lazy(() => import('./pages/ExpiredPage'));

function App() {
  return (
    <ErrorBoundary>
      <div className="min-h-dvh w-full overflow-x-hidden bg-mesh flex flex-col">
        <Suspense fallback={<LoadingScreen />}>
          <div className="flex flex-1 flex-col min-h-0">
            <Routes>
              <Route path="/preview" element={<PreviewPage />} />
              <Route path="/pay/:sessionId" element={<CheckoutPage />} />
              <Route path="/:sessionId" element={<CheckoutPage />} />
              <Route path="/success" element={<SuccessPage />} />
              <Route path="/status/:operationId" element={<OperationStatusPage />} />
              <Route path="/error" element={<ErrorPage />} />
              <Route path="/expired" element={<ExpiredPage />} />
              <Route path="*" element={<ErrorPage />} />
            </Routes>
          </div>
        </Suspense>
        <CheckoutFooter />
      </div>
    </ErrorBoundary>
  );
}

export default App;
